<template>
    <div class="template-container topbar-drop-container" v-show="selectedChannelRecid > 0">
        <div v-click-outside="hide" class='dropdown' id='template_wrapper' >
            <div class="btn-drop" :class="{expanded: showDropdown}" v-on:click="toggleDropdown">SELECT A TEMPLATE</div>
            <div id='template_select' class='dropdown-content' v-if="showDropdown">
                  <a v-for="template in templates"
                     :key="template.recid"
                     v-on:click="templateSelected(template)">
                        {{template.c_name}}
                  </a>
            </div>
        </div>
        <div class='dropdown selected-name' id='selected_template_name' v-if="selected">
           {{selected.c_name}}
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
   data() {
      return {
         selected: '',
         showDropdown: false
      }
   },
   computed: {
      ...mapState('global', [
         'templates'
      ]),
      ...mapState([
         'selectedChannelRecid'
      ])
   },
   methods: {
      ...mapActions('global', [
         'fetchTemplates',
      ]),
      ...mapActions([
         'selectTemplate',
      ]),
      toggleDropdown() {
         if (this.showDropdown) {
            this.showDropdown = false;
         } else {
            this.showDropdown = true;
         }
      },
      templateSelected(template) {
         this.selected = template;
         this.selectTemplate({templateRecid: template.recid});
         this.showDropdown = false;
      },
      getTemplates() {
         this.fetchTemplates({vm: this, channelRecid: this.selectedChannelRecid});
      },
      hide() {
         this.showDropdown = false;
      }
   },
   watch: {
      selectedChannelRecid: function (newVal, oldVal) { //when new channel ID is selected, get templates for that ID
         this.getTemplates();
         this.selected = '';
      }
   }
}
</script>

<!-- See ChannelList.vue for styles -->
<style lang="scss" scoped>

   .template-container {
      margin-right: 50px;
   }

   .topbar-drop-container {
      position: relative;
      display: flex;
      min-width: 394px;

      .selected-name {
         margin-left: 14px;
         color: $bard-gold;
      }

      &.template-container {
         margin-left: 10px;
      }
   }

   .dropdown-content {
      // margin-top: 19px;
      position: absolute;
      top: 37.5px;
      min-width: 100%;
      z-index: 101;
      padding: 0;
      border-radius: 0;
      background: rgb(94, 105, 129); /* fallback for older browsers, I hope we don't need this */
      background: rgba(94, 105, 129, 0.95);
      white-space: nowrap;

      a {
         color: white;
         padding: 2px 40px 2px 20px;
         text-decoration: none;
         display: block;

         &:not(:last-child) {
            border-bottom: .5px solid white;
         }

         &:hover {
            background: white;
            color: $bard-blue;
         }
      }
   }

   .btn-drop {
      position: relative;
      padding: 0;
      border: 0;
      background-color: transparent;
      color: white;
      font-size: 14px;
      border-radius: 0px;

      &:hover {
         background-color: transparent;
         cursor: pointer;
         border: none;
         outline: none;
      }
      
      &:after {
         display: inline-block;
         width: 10px;
         height: 10px;
         margin-left: 24px;
         content: '';
         border: 0;
         background-image: url('./../../assets/img/instances/SVGs/arrow-right.svg');
         background-repeat: no-repeat;
         background-size: 10px 10px;
      }

      &.expanded:after {
         background-image: url('./../../assets/img/instances/SVGs/arrow-down.svg');
      }
   }
</style>

